import { render, staticRenderFns } from "./accountSettings.vue?vue&type=template&id=8122fdd6&scoped=true"
import script from "./accountSettings.vue?vue&type=script&lang=js"
export * from "./accountSettings.vue?vue&type=script&lang=js"
import style0 from "./accountSettings.vue?vue&type=style&index=0&id=8122fdd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8122fdd6",
  null
  
)

export default component.exports